import { reactive, computed, toRefs } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
import useSortEntriesCompareFn from "@/util/useSortEntriesCompareFn.js";

export default function useProfileBulkEditorToolbarActions(
  items,
  selectedItems,
  gridApi
) {
  const store = useStore();
  const route = useRoute();
  const state = reactive({
    isLive: false,
  });

  const sortEntriesCompareFn = useSortEntriesCompareFn();
  const getEntries = computed(
    () => store.getters["api/category"](route.params.categoryID).entries
  );

  const deleteEntries = async () => {
    const deletions = selectedItems.value.map((item) => ({
      path: item.path,
      categoryID: route.params.categoryID,
    }));
    await store.dispatch("api/deleteBulk", {
      deletions,
      routeName: route.name,
    });
    // manually reset grid data after deletion
    gridApi.value?.setGridOption(
      "rowData",
      getEntries.value?.sort(sortEntriesCompareFn.value)
    );
  };

  const createBulkPatchObject = (attribute, attributeValue) =>
    selectedItems.value.map((item) => ({
      path: item.path,
      update: { [attribute]: attributeValue },
      categoryID: route.params.categoryID,
      entryID: item.path.split("entry/")[1],
    }));

  const togglePublish = async () => {
    const updates = createBulkPatchObject("isLive", !state.isLive);
    if (updates.length) {
      await store.dispatch("api/patchEntriesBulk", {
        updates,
        opts: { updateStoreFirst: true },
      });
      state.isLive = !state.isLive;
    }
  };

  return {
    ...toRefs(state),
    togglePublish,
    deleteEntries,
  };
}
